import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AgentDemo from './components/AgentDemo';
import './App.css';

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [currentView, setCurrentView] = useState('login');
  const [selectedAgent, setSelectedAgent] = useState(null);

  useEffect(() => {
    // Check for existing session
    const savedUser = localStorage.getItem('rmb_user');
    if (savedUser) {
      setCurrentUser(JSON.parse(savedUser));
      setCurrentView('dashboard');
    }
  }, []);

  const handleLogin = (user) => {
    setCurrentUser(user);
    localStorage.setItem('rmb_user', JSON.stringify(user));
    setCurrentView('dashboard');
  };

  const handleLogout = () => {
    setCurrentUser(null);
    localStorage.removeItem('rmb_user');
    setCurrentView('login');
    setSelectedAgent(null);
  };

  const handleStartDemo = (agentId) => {
    setSelectedAgent(agentId);
    setCurrentView('demo');
  };

  const handleBackToDashboard = () => {
    setSelectedAgent(null);
    setCurrentView('dashboard');
  };

  return (
    <div className="app">
      {currentView === 'login' && (
        <Login onLogin={handleLogin} />
      )}
      
      {currentView === 'dashboard' && (
        <Dashboard 
          user={currentUser} 
          onLogout={handleLogout}
          onStartDemo={handleStartDemo}
        />
      )}
      
      {currentView === 'demo' && (
        <AgentDemo 
          user={currentUser}
          agentId={selectedAgent}
          onBack={handleBackToDashboard}
          onLogout={handleLogout}
        />
      )}
    </div>
  );
}

export default App;
